import {
    sendMessage,
    updateSessionId,
    setPendingMessage,
    addMyChatMessage,
} from '../actions/ucmaActions';
import { orchestrator } from 'satcheljs';
import { getUserConfiguration } from 'owa-session-store';
import sendChatMessage from '../services/sendChatMessage';

orchestrator(sendMessage, actionMessage => {
    const { chat } = actionMessage;
    sendChatMessage(
        chat.sessionId,
        chat.recipients.map(recipient => recipient.sipUri),
        chat.pendingMessage
    ).then(sessionId => {
        if (sessionId != chat.sessionId) {
            updateSessionId(chat, sessionId);
        }
    });

    addMyChatMessage(
        chat,
        getUserConfiguration().SessionSettings.UserDisplayName,
        chat.pendingMessage
    );

    setPendingMessage(chat, '');
});
